import IDataNotFound from "../../../interfaces/data-not-found.interface";

export const DATA_NOT_FOUND: IDataNotFound = {
    title: "No hay comentarios para mostrar",
    description: "¡Ups, está sede no tiene comentarios!"
};